import VDialog from './VDialog';
export { VDialog };
export default VDialog;
//# sourceMappingURL=index.js.map